import { GET_AFFILIATE_REQUEST, ACCEPT_AFFILIATE_REQUEST, REJECT_AFFILIATE_REQUEST } from "./affiliateRequest.type";

const initialState = {
  affiliateRequest: {
    data: [],
    total: 0
  },
};

export const affiliateRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AFFILIATE_REQUEST:
      return {
        ...state,
        affiliateRequest: action.payload,
      };

    case ACCEPT_AFFILIATE_REQUEST:
      return {
        ...state,
        affiliateRequest: {
          ...state.affiliateRequest,
          data: state.affiliateRequest.data.filter(
            (request) => request._id !== action.payload
          ),
        },
      };

    case REJECT_AFFILIATE_REQUEST:
      return {
        ...state,
        affiliateRequest: {
          ...state.affiliateRequest,
          data: state.affiliateRequest.data.filter(
            (request) => request._id !== action.payload
          ),
        },
      };

    default:
      return state;
  }
};